export enum LibraryTypes {
  file = 'FILE',
  folder = 'FOLDER'
}